import { render } from "./Philosophy.vue?vue&type=template&id=7e0d7f54&scoped=true&ts=true"
import script from "./Philosophy.vue?vue&type=script&lang=ts"
export * from "./Philosophy.vue?vue&type=script&lang=ts"

import "./Philosophy.vue?vue&type=style&index=0&id=7e0d7f54&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e0d7f54"]])

export default __exports__